export const BOOKING_NUMBER_LENGTH = 10

export const VEHICLE_NUMBER_LENGTH = 4

export const BOOKING_STATUS = {
  All: 0,
  Unassigned: 1,
  Recept: 2,
  Booking: 3,
  Confirmed: 4,
  Delay_Expected: 5,
  Delay: 6,
  Arrival: 7,
  Calling: 8,
  Working: 9,
  Finish: 10,
} as const

export type BookingStatus = (typeof BOOKING_STATUS)[keyof typeof BOOKING_STATUS]

export const BOOKING_STATUS_LABEL = {
  [BOOKING_STATUS.Unassigned]: '未割当',
  [BOOKING_STATUS.Recept]: '受付済', // 未割り当ての受付済ステータス
  [BOOKING_STATUS.Booking]: '調整中',
  [BOOKING_STATUS.Confirmed]: '予約済',
  [BOOKING_STATUS.Delay_Expected]: '遅延見込',
  [BOOKING_STATUS.Delay]: '遅延',
  [BOOKING_STATUS.Arrival]: '受付済',
  [BOOKING_STATUS.Calling]: '呼出中',
  [BOOKING_STATUS.Working]: '作業中',
  [BOOKING_STATUS.Finish]: '完了',
} as const

export type BookingStatusLabel = (typeof BOOKING_STATUS_LABEL)[keyof typeof BOOKING_STATUS_LABEL]

/**
 * ステータス更新時の短縮時間フラグ（shorten_time_flag）。
 * BE 側の `Constant.FLAG_ON=1 / FLAG_OFF=0` に対応する on/off フラグ。
 * 作業完了時や強制完了時に ON を指定すると、BE が終了時刻を現在時刻付近にシフト（5分単位に丸め）する。
 */
export const SHORTEN_TIME_FLAG = {
  ON: 1,
  OFF: 0,
} as const

export type ShortenTimeFlag = (typeof SHORTEN_TIME_FLAG)[keyof typeof SHORTEN_TIME_FLAG]
